import { connect } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { operationsResponsive as creators } from '../../../../../../store/conversations';
import { getFileScanStatus } from '../../../../../../../core/selectors/fileScan';
import { isAntivirusFileScanEnabled } from '../../../../../../../core/constants/launchDarklyFeatureFlags';
import { resetAllFileScanStatuses } from '../../../../../../../core/actions/data/fileScan';
import EditMessageModal from './EditMessageModalAulaEditor';

const mapStateToProps = (state) => ({
  message: state.data.inboxv2.messages[state.inboxv2.currentlyEditedMessageId],
  saving: state.inboxv2.editingMessage,
  user: state.user.user,
  fileScanStatus: getFileScanStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
  save: async (content) => {
    await dispatch(creators.editMessage(content));
    dispatch(resetAllFileScanStatuses());
  },
  close: () => dispatch(creators.closeEditMessage()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { fileScanStatus, ...restState } = stateProps;
  const antivirusEnabled = isAntivirusFileScanEnabled(ownProps.flags);
  return {
    ...ownProps,
    ...restState,
    ...dispatchProps,
    editorConfig: antivirusEnabled
      ? {
          ...ownProps.editorConfig,
          fileScanStatus,
          enableFileScanStatus: true,
        }
      : ownProps.editorConfig,
    close: (...params) => {
      dispatchProps.close(...params);
      ownProps.onClose();
    },
  };
};

export default withLDConsumer()(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditMessageModal)
);
